module.exports = __webpack_public_path__ + "static/14-86db2450a8b3ead4a075e0f01de095c0.png";